import React, { useState } from "react";
import "./SellContactUs.css";
import { formattedText } from "@/components/sell/utils/TextFormatter";
import HubzuContactUsComModal from "../Modal/HubzuContactUsComModal";

const SellContactUs = ({ cmsData = [] }) => {
  // Safely access the data with fallbacks
  const hubzuCmsData = cmsData?.[0]?.contactUsSection || {};

  const [showContactUsCommercialModal, setShowContactUsCommercialModal] =
    useState(false);

  const comModalData = cmsData[0]?.contactUsComModal;

  const handleContactUsModal = () => {
    setShowContactUsCommercialModal(!showContactUsCommercialModal);
  };

  return (
    <div className="sell-contact-section text-center">
      <HubzuContactUsComModal
        isModalOpen={showContactUsCommercialModal}
        handleModal={handleContactUsModal}
        cmsData={comModalData}
      />
      <h2 className="benifitHead">{hubzuCmsData?.title}</h2>
      <div className="sell-contact-para">
        <div className="contact-sellPara">
          <p className="benifitLableNew">{hubzuCmsData?.description}</p>
          <div className="benifitCall">
            {formattedText(hubzuCmsData?.contact)}
          </div>
        </div>
      </div>
      {hubzuCmsData?.title && (
        <button
          className="btn btn-thm btn-lg sell-contact-today-button"
          onClick={handleContactUsModal}
        >
          Contact Us
        </button>
      )}
    </div>
  );
};

export default SellContactUs;
